import { PRODUCT_IDS } from '@adsk/alloy-provider';

/**
 * This method returns the project URL based on given project & current product ID
 * @return {string}
 */
export default (project, currentProductId) => {
  var _project$products;
  const productToLookFor = currentProductId === PRODUCT_IDS.ACCOUNT_ADMINISTRATION ? PRODUCT_IDS.PROJECT_ADMINISTRATION : currentProductId;
  const product = project === null || project === void 0 ? void 0 : (_project$products = project.products) === null || _project$products === void 0 ? void 0 : _project$products.find(p => p.key === productToLookFor);
  return (product === null || product === void 0 ? void 0 : product.defaultUrl) || project.defaultUrl;
};
//# sourceMappingURL=getProjectUrl.js.map